<div class="table-container">
    <section class="plans-section">
        <h2 [innerHTML]="this.tableNutritionContent.title"></h2>

        <div class="plan-list-container">
            <div class="plan-list">
                <div class="plan-item" *ngFor="let item of this.tableNutritionContent.contents">
                    <div class="plan-title">

                        <p><strong>{{item.title}}</strong></p>
                    </div>
                    <span>{{item.subtitle}}</span>
                </div>
            </div>
        </div>
    </section>
</div>